import Logo from '../../../components/base/Logo';

export default function Footer() {
  return (
    <footer className="bg-[#1A2B3C] text-white border-t border-white/8">
      <div className="py-10 md:py-14 border-b border-white/8">
        <div className="max-w-6xl mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <Logo className="h-8 mb-4" />
              <p className="text-white/40 text-xs leading-relaxed mb-4">
                Sistema de verificación y activación comercial automotriz para conductores registrados en Bogotá D.C. Operado por GESTIÓN AUTOMOTRIZ AW2020 SAS en alianza con proveedores de llantas verificados.
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-[#28A745]/10 border border-[#28A745]/20 rounded-full text-[#28A745] text-[10px] font-semibold">
                  <i className="ri-map-pin-fill text-xs"></i>
                  Bogotá D.C.
                </span>
              </div>
            </div>

            <div>
              <h4 className="text-white font-bold text-xs uppercase tracking-wider mb-4 flex items-center gap-1.5">
                <i className="ri-building-line text-[#28A745] text-sm"></i>
                Respaldo institucional
              </h4>
              <div className="p-4 bg-white/5 border border-white/8 rounded-xl mb-3">
                <p className="text-white text-xs font-black mb-1">GESTIÓN AUTOMOTRIZ AW2020 SAS</p>
                <p className="text-white/40 text-[10px] leading-relaxed">
                  NIT 901401495<br />
                  Carrera 76 No. 77A – 45<br />
                  Bogotá D.C., Colombia
                </p>
              </div>
              <p className="text-white/30 text-[10px]">
                Alianza comercial con proveedores de llantas verificados
              </p>
            </div>

            <div>
              <h4 className="text-white font-bold text-xs uppercase tracking-wider mb-4 flex items-center gap-1.5">
                <i className="ri-car-line text-[#28A745] text-sm"></i>
                Únete al programa
              </h4>
              <p className="text-white/40 text-xs leading-relaxed mb-4">
                Regístrate y accede a todos los beneficios del sistema de verificación automotriz para conductores de Bogotá.
              </p>
              <button onClick={() => { const el = document.getElementById('registro-form'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' }); }} className="flex items-center gap-2 text-[#28A745] hover:text-[#28A745]/80 transition-colors text-xs cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-sm"></i>
                Registrar mi vehículo
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="py-6 border-b border-white/8">
        <div className="max-w-4xl mx-auto px-4">
          <div className="bg-white/4 border border-white/8 rounded-xl p-5">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-7 h-7 flex items-center justify-center bg-white/8 rounded-lg flex-shrink-0">
                <i className="ri-scales-3-line text-white/50 text-sm"></i>
              </div>
              <p className="text-white/50 text-xs font-bold uppercase tracking-wider">Aviso legal y protección de datos</p>
            </div>
            <p className="text-white/30 text-[10px] leading-relaxed mb-2">
              La adjudicación de beneficios está sujeta a los términos del programa de fidelización y los resultados oficiales de la Lotería de Bogotá. Los valores de diagnóstico son 100% redimibles en el servicio de RTM. Responsabilidad exclusiva de <strong className="text-white/45">GESTIÓN AUTOMOTRIZ AW2020 SAS</strong>.
            </p>
            <p className="text-white/30 text-[10px] leading-relaxed mb-2">
              Los datos personales suministrados serán tratados conforme a la <strong className="text-white/45">Ley 1581 de 2012</strong> (Protección de Datos Personales) y el Decreto 1377 de 2013. El titular autoriza a <strong className="text-white/45">GESTIÓN AUTOMOTRIZ AW2020 SAS</strong> para recolectar, almacenar y usar su información con fines de gestión de servicios automotrices y comunicaciones comerciales relacionadas.
            </p>
            <p className="text-white/30 text-[10px] leading-relaxed">
              <strong className="text-white/45">Este sistema no constituye un juego de azar ni una actividad de apuestas.</strong> Es un programa de fidelización y activación comercial para usuarios registrados, que utiliza los resultados públicos de la Lotería de Bogotá como mecanismo de activación semanal de beneficios. No implica apuesta, riesgo económico ni promesa de ganancia para el usuario.
            </p>
          </div>
        </div>
      </div>

      <div className="py-4">
        <div className="max-w-6xl mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-white/25 text-[10px]">© 2025 ALAFIJAYA · GESTIÓN AUTOMOTRIZ AW2020 SAS · NIT 901401495 · Bogotá D.C.</p>
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/20 hover:text-white/40 text-[10px] transition-colors">Powered by Readdy</a>
        </div>
      </div>
    </footer>
  );
}
